import React from 'react';
import PropTypes from 'prop-types';
import { Polyline as VisGlPolyline } from '@vis.gl/react-google-maps';

// @vis.gl/react-google-maps' Polyline takes google.maps.PolylineOptions as flat top-level props,
// but every call site in this app (carried over from @react-google-maps/api) passes them via
// an `options` object. This keeps those call sites unchanged.
const Polyline = React.forwardRef(({ options, ...props }, ref) => (
  <VisGlPolyline ref={ref} {...options} {...props} />
));

Polyline.displayName = 'Polyline';

Polyline.propTypes = {
  options: PropTypes.object
};

export default Polyline;
